<template>
  <div class="home">
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit">
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="应用">
          <SelectCustomize :value="searchForm.appid" :data="apps" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="SDK包" prop="uid">
          <el-input v-model.trim="searchForm.pkg_name" placeholder="输入SDK包" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="调用权限" prop="uid">
          <el-input
            v-model.trim="searchForm.permissions"
            placeholder="输入调用权限"
          />
        </el-form-item>
      </el-col>
      <el-button @click="initFrom" slot="btn-option">重置筛选</el-button>
    </FilterLayout>
    <TableLayout
      :column="column"
      :data="tableData.data"
      :total="tableData.total"
      :loading="tableData.loading"
      :currentPage="tableOpt.currentPage"
      :leadOut="true"
      :params="outPamrms"
      leadApi="sdk_auth/list"
      @sizeChange="onSizeChange"
      @pageChange="onPageChange"
    >
      <template slot="table-option">
        <el-button
          type="primary"
          v-if="indexFlag"
          @click="
            () =>
              this.$router.push({
                path: '/business_center/subsidiary_management/sdk/component/maintain',
              })
          "
        >
          注释维护
        </el-button>
      </template>
      <template #permissions="{ row }">
        <el-tag
          size="small"
          style="margin: 5px 5px 0 5px"
          type="info"
          v-for="(item, index) in row.permissions"
          :key="index"
          >{{ item }}</el-tag
        >
      </template>
    </TableLayout>
  </div>
</template>

<script>
import moment from "moment";
import store from "store2";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import SelectCustomize from "@/component/select-customize";

export default {
  name: "home",
  components: {
    FilterLayout,
    TableLayout,
    SelectCustomize,
  },
  data() {
    return {
      searchForm: {
        appid: {
          appInfo: [],
        },
        pkg_name: "",
        permissions: "",
      },
      column: [
        {
          prop: "appid_name",
          label: "应用",
          width: "150",
        },
        {
          prop: "pkg_name",
          label: "SDK包",
          width: "380",
        },
        {
          prop: "permissions",
          label: "调用权限",
        },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      // 表格数据
      tableData: {
        data: [], //数据
        total: 0, //总页数
        currentPage: 1, //当前页
        pageSize: 10, //每页条数
        loading: false, //加载标杆
      },
      apps: [], //应用列表
      indexFlag:true,//权限控制
    };
  },
  mounted() {
    // 调用权限列表
    let arr = store.get("menu");
    this.indexFlag = arr.indexOf("155");
    this.getRoleBtree();
    this.getReport();
  },
  computed: {
    outPamrms() {
      const { searchForm, sort, tableOpt } = this;
      let obj = {
        currentPage: 1,
        pageSize: 100,
        appid: searchForm.appid.appInfo,
        permissions: searchForm.permissions,
        pkg_name: searchForm.pkg_name,
      };
      return obj;
    },
  },
  methods: {
    // 获取筛选项表单数据
    async getRoleBtree() {
      const [err, res] = await this.$http.post("System/roleBtree", {
        loginId: store.get("user")["id"],
        loginToken: store.get("loginToken"),
      });
      if (err) return;
      this.department_id = res.tree;
      let apps = [];
      let article_id_arr = [];
      res.list.forEach((item) => {
        if (item.title == "项目") {
          article_id_arr = item.node;
        }
        if (item.title == "应用") {
          item.node.forEach((_item) => {
            if (_item.system == "1") {
              _item.title = _item.title + "_Android";
            } else if (_item.system == "2") {
              _item.title = _item.title + "_IOS";
            } else if (_item.system == "3") {
              _item.title = _item.title + "_微信小程序";
            }
          });
          apps = item.node;
        }
      });
      this.apps = apps;
    },
    // 表单提交
    onSubmit() {
      this.tableOpt.currentPage = 1
      this.getReport();
    },
    // 列表获取
    async getReport() {
      this.tableData.loading = true;
      const { searchForm, tableOpt } = this;
      const [err, res] = await this.$http.post("sdk_auth/list", {
        ...tableOpt,
        appid: searchForm.appid.appInfo,
        permissions: searchForm.permissions,
        pkg_name: searchForm.pkg_name,
      });
      this.tableData.loading = false;
      if (err) {
        this.tableData = {
          list: [],
          total: 0,
          currentPage: 1,
          pageSize: 10,
          loading: false,
        };
        return;
      }
      const { list, currentPage, total } = res;
      this.tableData.data = list;
      this.tableData.currentPage = currentPage;
      this.tableData.total = total;
    },
    onPageChange(current) {
      this.tableOpt.currentPage = current;
      this.getReport();
    },
    onSizeChange(current) {
      this.tableOpt.pageSize = current;
      this.getReport();
    },
    // 重置表单
    initFrom() {
      this.searchForm = {
        appid: {
          appInfo: [],
        },
        pkg_name: "",
        permissions: "",
      };
      this.tableOpt.currentPage = 1;
      this.getReport();
    },
    // 格式化请求参数
    formatSearch(name) {
      let data = this.searchForm[name].appInfo.join()
        ? this.searchForm[name].appInfo.join()
        : undefined;
      return data;
    },
  },
};
</script>

<style lang="less" scoped>
.component_title {
  background: #fff;
  padding: 20px 0 10px 15px;
  font-weight: bold;
}
</style>
